import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { range } from 'lodash';
import { changeTextProperty } from '../../../redux/actions/entities/texts';

class FontSize extends Component {
  constructor(...args) {
    super(...args);
    this.range = range(20, 230, 5);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {
    const { textFieldId } = this.props;
    const { value } = event.target;
    this.props.dispatch(changeTextProperty(textFieldId, 'fontSize', parseInt(value, 10)));
  }

  options = () => this.range.map(element => <option value={element} key={`size-${element}`} >{element} px</option>)

  render() {
    return (
      <div className="textToolsIcon">
        <svg
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          viewBox="0 0 18 14"
          enableBackground="new 0 0 18 14"
          xmlSpace="preserve"
          style={{ width: '18px' }}
        >
          <path fill="#555555" d="M0,6v2h1V7h2v6H2v1h4v-1H5V7h2v1h1V6H0z M5,0v4h2V2h3v10H8v2h7v-2h-2V2h3v2h2V0H5z" />
        </svg>
        <select className="fontSize" value={parseInt(this.props.fontSize, 10)} name="fontSize" onChange={this.handleChange}>
          { this.options() }
        </select>
      </div>
    );
  }
}

FontSize.defaultProps = {
  textFieldId: 0,
  fontSize: 35,
  dispatch: () => {},
};

FontSize.propTypes = {
  textFieldId: PropTypes.number,
  fontSize: PropTypes.number,
  dispatch: PropTypes.func,
};

export default connect()(FontSize);



// WEBPACK FOOTER //
// ./src/components/text-tools/font-size/FontSize.jsx